import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth/auth.service';
import { Router, RouterModule } from '@angular/router';
import { FirebaseError } from '@angular/fire/app';
import { AuthErrorConstants } from '../../core/messages';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
  template: `
    <div class="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div class="sm:mx-auto sm:w-full sm:max-w-sm">
        <a routerLink="/" class="hover:cursor-pointer">
          <img
            class="mx-auto h-10 w-auto"
            src="assets/logo-min.webp"
            alt="Columbus Logo"
          />
        </a>
        <h2
          class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900"
        >
          Sign in to your account
        </h2>
      </div>

      <div class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form class="space-y-6" [formGroup]="loginForm">
          <div>
            <label
              for="email"
              class="block text-sm font-medium leading-6 text-gray-900"
              >Email address</label
            >
            <div class="mt-2">
              <input
                id="email"
                name="email"
                type="email"
                formControlName="email"
                autocomplete="email"
                required
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-columbus-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <div class="flex items-center justify-between">
              <label
                for="password"
                class="block text-sm font-medium leading-6 text-gray-900"
                >Password</label
              >
            </div>
            <div class="mt-2">
              <input
                id="password"
                name="password"
                type="password"
                formControlName="password"
                autocomplete="current-password"
                required
                class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-columbus-blue-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <button
              (click)="onSubmit()"
              [disabled]="loginForm.invalid"
              type="button"
              class="flex w-full justify-center disabled:opacity-25 rounded-md bg-columbus-blue-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-columbus-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600"
            >
              Sign in
            </button>
          </div>
          <div *ngIf="isError" class="flex w-full justify-center text-center">
            <p class="font-bold text-red-500 italic">{{ errorMsg }}</p>
          </div>
        </form>
      </div>
    </div>
  `,
  styles: ``,
})
export class LoginComponent {
  private fb = inject(FormBuilder);

  private authService = inject(AuthService);
  private router = inject(Router);

  errorMsg = '';
  isError = false;

  loginForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
  });

  onSubmit() {
    const rawLoginForm = this.loginForm.getRawValue();
    if (rawLoginForm.email && rawLoginForm.password) {
      this.authService
        .login(rawLoginForm.email, rawLoginForm.password)
        .subscribe({
          next: () => this.router.navigateByUrl('/dashboard'),
          error: (error) => {
            const code = error.code.slice(5, error.code.length);
            if (
              error instanceof FirebaseError &&
              code in AuthErrorConstants.authErrors
            ) {
              this.errorMsg = AuthErrorConstants.authErrors[code];

              //  console.log(this.errorMsg);
            } else {
              this.errorMsg =
                'An unknown error occurred. Please try again later.';
            }

            this.isError = true;

            console.error(error);
          },
        });
    }
  }
}
